import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, startWith, takeUntil } from 'rxjs/operators';
import { PayeeCasesService } from '../payee-cases.service';
import { isMoment } from 'moment';

@Component({
  selector: 'payee-case-started-at-filter',
  templateUrl: './case-started-at-filter.component.html',
  styleUrls: ['./case-started-at-filter.component.scss']
})
export class CaseStartedAtFilterComponent implements OnInit, OnDestroy {
  private readonly destroy = new Subject<void>();

  readonly form: FormGroup;
  get fromControl() { return this.form.get('from') as FormControl; };
  get toControl() { return this.form.get('to') as FormControl; };

  get selected(): boolean {
    return !!this.payeeCasesService.started_at_min.value || !!this.payeeCasesService.started_at_max.value;
  }

  dropdownOpen = false;

  constructor(
    private payeeCasesService: PayeeCasesService,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      from: null,
      to: null,
    });
  }

  ngOnInit(): void {
    this.payeeCasesService.started_at_min
      .pipe(
        takeUntil(this.destroy),
        startWith(this.payeeCasesService.started_at_min.value),
        map(v => isMoment(v) ? v.format('YYYY-MM-DD') : v),
        distinctUntilChanged(),
      )
      .subscribe(v => {
        this.fromControl.patchValue(v, { emitEvent: false });
      });

    this.payeeCasesService.started_at_max
      .pipe(
        takeUntil(this.destroy),
        startWith(this.payeeCasesService.started_at_max.value),
        map(v => isMoment(v) ? v.format('YYYY-MM-DD') : v),
        distinctUntilChanged(),
      )
      .subscribe(v => {
        this.toControl.patchValue(v, { emitEvent: false });
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  applyFilter(): void {
    this.payeeCasesService.started_at_min.next(this.fromControl.value);
    this.payeeCasesService.started_at_max.next(this.toControl.value);
    this.dropdownOpen = false;
  }

  clearFilter(): void {
    this.fromControl.patchValue(null);
    this.toControl.patchValue(null);
    this.payeeCasesService.started_at_min.next(null);
    this.payeeCasesService.started_at_max.next(null);
    this.dropdownOpen = false;
  }

  readonly displayWith = (): string => {
    const {
      startedAtMin,
      startedAtMax,
    } = this.payeeCasesService.getFilters();

    return `${startedAtMin ?? ''} - ${startedAtMax ?? ''}`.trim();
  };
}
